import dayjs from "dayjs";

export const combineDateAndTime = (params: any[]) => {
  const date = params[0] as string | null;
  const time = params[1] as string | null;

  if (!date || !time) return null;

  const [hours, minutes] = time.split(":").map(Number);
  const combined = dayjs(date).hour(hours).minute(minutes);

  return combined.isValid() ? combined.toDate() : null;
};
